// extracted by mini-css-extract-plugin
export default {"headerDashboard":"HeaderDashboard_headerDashboard__5wknI"};